import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Link, { linkBase } from '@src/mobile/components/Link';
import { useFixedNav } from '@src/mobile/hooks';
import { isGrounds, groundsClose, openAppShare } from '@src/mobile/utils/app';
import styles from './index.css';
import { Store } from '../store';

const cx = classNames.bind(styles);

const Banner = () => {
    // store
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { statusBarHeight, list, showFixedNav, shareTitle, shareDesc, shareThumbnail } = states;

    // 中国的数据
    const china = list.find(item => {
        const { country } = item;

        return country === '中国';
    });

    // nav的ref
    const navRef = useRef();
    // banner的ref
    const wrapRef = useRef();
    // 展示nav背景的高度
    const [fixedTop, setFixedTop] = useState(0);

    useEffect(
        () => {
            if (navRef.current && wrapRef.current) {
                setFixedTop(wrapRef.current.offsetHeight - navRef.current.offsetHeight);

                changeStates({ navHeight: navRef.current.offsetHeight });
            }
        },
        [statusBarHeight],
    );

    useFixedNav(fixedTop, showFixedNav => {
        changeStates({ showFixedNav });
    });

    const handleBackClick = () => {
        groundsClose();
    };

    const handleShareClick = () => {
        openAppShare({
            title: shareTitle,
            desc: shareDesc,
            thumbnail: shareThumbnail,
        });
    };

    return (
        <>
            {isGrounds ? (
                <div className={styles.nav} style={{ paddingTop: statusBarHeight }} ref={navRef}>
                    <div className={cx('navBg', { showNavBg: showFixedNav })} />
                    <div className={styles.navContent}>
                        <div className={styles.navBack} onClick={handleBackClick} />
                        <div className={cx('navTitle', { showNavTitle: showFixedNav })}>奖牌榜</div>
                        <div className={styles.navShare} onClick={handleShareClick} />
                    </div>
                </div>
            ) : null}

            <div className={cx('wrap', { wrapShare: !isGrounds })} ref={wrapRef}>
                {china ? (
                    <div className={styles.proud}>
                        <Link to={`${linkBase}/loc/beijing2022/honor`} className={styles.proudLink}>
                            <div className={styles.proudContent}>
                                <div className={styles.proudInfo}>
                                    <div className={styles.proudFlag}>
                                        <img src={china.url} alt="" />
                                    </div>
                                    <div className={cx('proudText', 'proudTextRed')}>中国已获</div>
                                    <div className={cx('proudMedal', 'proudMedalGold')} />
                                    <div className={styles.proudText}>金:{china.goldNum}</div>
                                    <div className={cx('proudMedal', 'proudMedalSilver')} />
                                    <div className={styles.proudText}>银:{china.silverNum}</div>
                                    <div className={cx('proudMedal', 'proudMedalCopper')} />
                                    <div className={styles.proudText}>铜:{china.copperNum}</div>
                                </div>
                                <div className={styles.proudArrow} />
                            </div>
                        </Link>
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default errorBoundary(Banner);
